import getAxiosInstance from 'api';

export const CREDIT_RISK_PRODUCT = {
  productCode: 'affordability_full',
  productPlan: 'Platinum_Basic',
};

export const PERMISSION_FIELDS = {
  FEATURE: 'permissions',
  TRANSACTION: 'transactionPermissions',
};

export function parseProductPermissionsResponse(data) {
  if (Array.isArray(data)) {
    return {
      [PERMISSION_FIELDS.FEATURE]: data,
      [PERMISSION_FIELDS.TRANSACTION]: [],
    };
  }

  if (data && typeof data === 'object') {
    return {
      [PERMISSION_FIELDS.FEATURE]: Array.isArray(data.permissions)
        ? data.permissions
        : [],
      [PERMISSION_FIELDS.TRANSACTION]: Array.isArray(data.transactionPermissions)
        ? data.transactionPermissions
        : [],
    };
  }

  return {
    [PERMISSION_FIELDS.FEATURE]: [],
    [PERMISSION_FIELDS.TRANSACTION]: [],
  };
}

export function getPermissionList(data, field) {
  return parseProductPermissionsResponse(data)[field] || [];
}

export function getSelectedPermissionsFromProduct(product, field) {
  return Array.isArray(product?.[field]) ? product[field] : [];
}

export function getCreditRiskProductFromPricing(pricingData) {
  const products = pricingData?.products;
  if (!Array.isArray(products)) {
    return null;
  }

  return (
    products.find(
      (item) =>
        item.productCode === CREDIT_RISK_PRODUCT.productCode &&
        item?.productPlan === CREDIT_RISK_PRODUCT.productPlan
    ) || null
  );
}

export function getBusinessPartnerIdFromEntitlement(entitlement) {
  return (
    entitlement?.businessPartnerId ??
    entitlement?.business?.id ??
    entitlement?.businessId ??
    null
  );
}

export function fetchProductPermissionsMaster(planId, journeyType) {
  return getAxiosInstance(
    'adminOrchestrator/businessPartner/getProductPermissionsMaster',
    'post',
    { planId },
    { 'journey-type': journeyType }
  ).then((res) => {
    if (res?.data?.codes === 200) {
      return parseProductPermissionsResponse(res?.data?.data);
    }
    return parseProductPermissionsResponse(null);
  });
}

export function fetchBusinessPartnerPricing(businessPartnerId, journeyType) {
  return getAxiosInstance(
    `adminOrchestrator/businessPartner/${businessPartnerId}/pricing`,
    'get',
    {},
    { 'journey-type': journeyType }
  );
}

export function updateProductPermissions({
  productEntitlementId,
  permissions,
  transactionPermissions,
  journeyType,
}) {
  return getAxiosInstance(
    'adminOrchestrator/businessPartner/updateProductPermissions',
    'post',
    {
      productEntitlementId,
      permissions,
      transactionPermissions,
    },
    { 'journey-type': journeyType }
  );
}

export async function loadCreditRiskPermissionState({
  planId,
  entitlement,
  businessPartnerId,
  journeyType,
}) {
  const [masterPermissions, pricingRes] = await Promise.all([
    planId
      ? fetchProductPermissionsMaster(planId, journeyType)
      : Promise.resolve(parseProductPermissionsResponse(null)),
    businessPartnerId
      ? fetchBusinessPartnerPricing(businessPartnerId, journeyType)
      : Promise.resolve(null),
  ]);

  const pricingProduct = pricingRes?.data?.data
    ? getCreditRiskProductFromPricing(pricingRes.data.data)
    : null;

  const selectedSource = pricingProduct || entitlement?.plan || entitlement || {};
  const pricingData = pricingRes?.data?.data;
  console.log('pricingData', pricingData)
  return {
    partnerType:
      pricingData?.partnerType ??
      entitlement?.partnerType ??
      entitlement?.business?.partnerType ??
      null,
    productPermissionOptions:
      masterPermissions[PERMISSION_FIELDS.FEATURE] || [],
    transactionPermissionOptions:
      masterPermissions[PERMISSION_FIELDS.TRANSACTION] || [],
    selectedProductPermissions: getSelectedPermissionsFromProduct(
      selectedSource,
      PERMISSION_FIELDS.FEATURE
    ),
    selectedTransactionPermissions: getSelectedPermissionsFromProduct(
      selectedSource,
      PERMISSION_FIELDS.TRANSACTION
    ),
  };
}

/** @deprecated Use parseProductPermissionsResponse instead. */
export function normalizeProductPermissionOptions(data) {
  const parsed = parseProductPermissionsResponse(data);
  return [
    ...parsed[PERMISSION_FIELDS.FEATURE],
    ...parsed[PERMISSION_FIELDS.TRANSACTION],
  ];
}
